import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import "./styles.scss"; // Importa o CSS customizado

const ModalMarkdown = ({ show, handleClose, fileUrl }) => {
  const [markdownContent, setMarkdownContent] = useState("");

  useEffect(() => {
    if (fileUrl) {
      fetch(fileUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Erro na resposta da rede");
          }
          return response.text();
        })
        .then((text) => setMarkdownContent(text))
        .catch((error) =>
          console.error("Erro ao carregar o arquivo Markdown:", error)
        );
    }
  }, [fileUrl]);

  return (
    <Modal size="lg" show={show} onHide={handleClose} className="modal-custom">
      <Modal.Header closeButton>
        <Modal.Title>Políticas de Privacidade</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalMarkdown;
